import React from 'react'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import irelandApi from '../irelandApi'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

const prepareFormData = (payLoad) => {
  let formData = new FormData();
  Object.keys(payLoad).forEach(key => {
    formData.append(`download[${key}]`, payLoad[key])
  });
  return formData;
};


export const getFiles = () => (dispatch) => {
  dispatch({type: 'GET_FILES_PENDING', payload: []});

  return irelandApi.get('/api/admin/downloads')
                   .then((response) => {
                     dispatch({type: 'GET_FILES_FULFILLED', payLoad: response.data})
                   })
                   .catch(function (error) {
                     dispatch({type: 'GET_FILES_REJECTED', payLoad: error});
                   });
};

export const uploadFile = (payLoad) => {
  let formData = prepareFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.post('/api/admin/downloads', formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="File has been saved successfully"/>);
                     store.dispatch(actions.reset('deep.admin_files.upload'));
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save file"/>);
                     store.dispatch(actions.resetValidity('deep.admin_files.edit'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};

export const getFile = (id) => (dispatch) => {
  dispatch({type: "GET_FILE_PENDING"});
  return irelandApi.get(`/api/admin/downloads/${id}`)
                   .then((response) => {
                     const attributes = response.data.data.attributes;
                     const data = {
                       name: attributes.name || ''
                     };
                     dispatch(actions.load('deep.admin_files.edit', data));
                     dispatch({type: "GET_FILE_FULFILLED", payLoad: response.data});
                   })
                   .catch((error) => {
                     dispatch({type: 'GET_FILE_REJECTED', payLoad: error.data})
                   })
};

export const deleteFile = (id) => (dispatch) => {
  dispatch({type: "DELETE_FILE_PENDING"});
  return irelandApi.delete(`/api/admin/downloads/${id}`)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="File has been deleted successfully"/>);
                     dispatch({type: "DELETE_FILE_FULFILLED", payLoad: id});
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occured during delete file"/>);
                     dispatch({type: 'DELETE_FILE_REJECTED', payLoad: error.data});
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data);
                   })
};

export const updateFile = (id, payLoad) => {
  let formData = prepareFormData(payLoad);
  const config = {
    headers: { 'content-type': 'multipart/form-data' }
  };
  return irelandApi.patch(`/api/admin/downloads/${id}`, formData, config)
                   .then((response) => {
                     toast.success(<ToastMessage iconStyle="success"
                                                 message="File has been saved successfully"/>);
                     history.push('/admin/downloads');
                   })
                   .catch((error) => {
                     toast.error(<ToastMessage iconStyle="error"
                                               message="An error occurred during save file"/>);
                     store.dispatch(actions.resetValidity('deep.admin_file.edit'));
                     const data = {
                       ...error.response.data.errors
                     };
                     return Promise.reject(data)
                   })
};



// WEBPACK FOOTER //
// ./src/actions/files.js